const TypeOptin = {
	Default: 0,

	DisableWithOptin: 1,

	DisableWithOptout: 2
};

export default TypeOptin;